import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface StepFormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

export const StepForm = forwardRef<HTMLFormElement, StepFormProps>(
  ({ hidden, className, children, ...restProps }, ref) => {
    if (hidden || !children) {
      return null;
    }

    return (
      <form
        ref={ref}
        autoComplete="off"
        className={twMerge('relative flex h-full w-full flex-1 flex-col', className)}
        {...restProps}
      >
        {children}
      </form>
    );
  },
);

StepForm.displayName = 'StepForm';
